import React, {FC} from "react"

import {Container} from "./styled"
import {SpacingProps} from "../../global/css"

export interface Props extends SpacingProps {}

const Card: FC<Props> = (props) => {
  return <Container {...props}>{props.children}</Container>
}

export default Card
